import { Notification } from 'element-ui'
const instances = []
const newNotification = options => {
  if (instances.length <= 2) {
    instances.push(Notification(options))
  } else {
    instances[0].close()
    instances.shift()
    instances.push(Notification(options))
  }
}
const notificationList = ['error', 'success', 'info', 'warning']
notificationList.forEach(type => {
  newNotification[type] = options => {
    if (typeof options === 'string') {
      options = {
        message: options
      }
    }
    options.type = type
    return newNotification(options)
  }
})
export const notification = newNotification
